<template functional>
  <img
    :src="(`/modules/openweb/js/vue/src/assets/icons/${props.name}.svg`)"
  >
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
img {
  width: 16px;
  height: 16px;
}
</style>
